import { render, staticRenderFns } from "./TemplateNotificationCategories.vue?vue&type=template&id=49093f52&"
import script from "./TemplateNotificationCategories.vue?vue&type=script&lang=js&"
export * from "./TemplateNotificationCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports